<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 comments-datatable">        
        
        <app-table :id="tableId" id="comments-table" :filtered-data="filteredData" :options="options" />
        
        
        
    </div>
</template>

<script>
    import * as actions from "../../../../../Config/ApiUrl";
    
    
    export default {
        name: "commentDatatable",
        props: {
           candidateId: Number,
           status: Number
        },
        data() {
            return {
                preloader: false,
                tableId: 'comments-table',
                filteredData: {
                    status: '',
                },
                options: {
                    url: actions.COMMENTS_DATA,
                    name: this.$t('basic_list_view_table'),
                    showHeader: false,
                    columns: [
                        {
                            title: this.$t('comments'),
                            type: 'custom-html',
                            class: 'comments-text',
                            key: 'comment',
                            modifier: (value) => {
                                if (value) {
                                    let filename_formatted = value.split("/").pop().replace(/\-\d.*/,'');
                                    let filetype = '.'+value.split(".").pop();
                                    let target = '_self';
                                                                        
                                    return `<div>${value}</div>`;
                                    
                                    
                                } 
                            }

                        },
                    ],
                    filters: [
                        {
                            "title": this.$t('candidate_id'),
                            "type": "drop-down-filter",
                            "key": "filter-with-candidate",
                            "initValue": this.candidateId,
                            "option": [],
                        },
                        {
                            "title": this.$t('status'),
                            "type": "drop-down-filter",
                            "key": "filter-with-status",
                            "initValue": this.status, 
                            "option": [],
                        },
                    ],
                    
                    showFilter: false,
                    showSearch: false,
                    paginationType: "hidden",
                    emptyText: "", // Text if zero results
                    showEmptyAnimation: false,
                    datatableWrapper: true,
                    actions:[],
                    responsive: false,
                    rowLimit: 1,
                    showAction: false,
                    showCount: false,
                    showOnlyTotal: true, // Show only total number of comments
                    showClearFilter: false,
                    managePagination: false,
                    tableShadow: false,
                    tablePaddingClass: '',
                    orderBy: 'desc',
                },

                methods: {
                    /**
                    * get Status Filter
                    */
                    getSearchValue(value) {
                        let instance = this;
                        this.search = value;
                        setTimeout(function () {
                            instance.$hub.$emit('reload-' + instance.tableId);
                        });
                    },
                    getFilterValue(item) {
                        this.filteredData.status = item;
                        this.$hub.$emit('reload-'+this.tableId);
                    }
                      
                }
            }
        }
    }
</script>
